module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-disney-1-4cfe4f59136a77be42efb5d5d3f1fc14.webp";